<template>
<CModal v-model="showDetail" :title="form.title" width="800" footerHide>
    <div class="content_box">
        <div class="detail">{{getDate(form.createTime)}} 作者：{{form.author}}</div>
        <div class="content" v-if="form.content" v-html="form.content"></div>
        <div class="content" v-else>暂无信息</div>
    </div>
</CModal>

</template>
<script>
import { getDate } from './information_public.js'
import CModal from '@/components/cModel'
export default {
  components:{
    CModal
  },
  data () {
    return {
      form: {},
      showDetail: false
    }
  },
  methods: {
    showModel (detail) {
      this.showDetail = true
      this.form = detail
    },
    // 转时间
    getDate (time) {
      return getDate(time)
    }
  }
}
</script>
<style>
.content_box .detail{text-align: center;line-height: 30px;font-size: 12px;color: #666;margin-bottom: 20px;}
.content_box .content{padding:0 20px;font-size: 14px;}
.content_box .content img{max-width: 100%;height: auto;margin: 0;}
.content_box .content p{margin:5px 0;}
</style>
